<template>
    <div class="page flex-col">
        <div class="box_1 flex-col">
            <div class="group_2 flex-row">
                <div class="image-text_25 flex-row justify-between">
                    <img class="label_1" referrerpolicy="no-referrer" src="static/img/mobile/scanImage.png" @click="openScan" />
                    <!-- <span class="text-group_1">关键字搜索</span> -->
                    <el-input type="text" name="fname" class="text-group_1" placeholder="扫描腕带/输入住院号" :clearable="true" v-model="scan_userCode" ref="userCode" />
                </div>
            </div>
        </div>
        <div class="section_3 flex-col">
            <vdropdownmenu>
                <vdropdownitem title="手术时间" class="image-text_26 flex-row justify-between" v-model="activeOperTime" :options="operTimes" @click.native="handlerOperTime()"/>
                <vdropdownitem title="手术状态" class="image-text_27 flex-row justify-between" v-model="activeStatus" multiple :options="allStatus" />
                <vdropdownitem title="手术房间" class="image-text_28 flex-row justify-between" ref="item">
                    <div class="dropdownRooms flex-col">
                        <!-- xunhuan -->
                        <div v-for="(ward, index) in operateWards" :key="index">
                            <div v-if="ward.code == '手术区'">
                                <div class="wardpanel">{{ ward.label }}</div>
                                <div v-if="ward.operation_room && ward.operation_room.length > 0" class="roompanel">
                                    <div
                                        class="room"
                                        @click="selectedRooms(room.value, 1)"
                                        :class="{ room_active: selectedOperateRoomIds.indexOf(room.value) > -1 }"
                                        v-for="(room, r_idx) in ward.operation_room"
                                        :key="r_idx"
                                    >
                                        {{ room.label }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="wardpanel">
                            复苏室
                            <div class="roompanel">
                                <template v-for="(ward, index) in operateWards">
                                <div
                                    class="room"
                                    v-if="ward.code == '复苏室'"
                                    @click="selectedRooms(ward.origion, 2)"
                                    :class="{ room_active: selectedRecoveryRoomIds.indexOf(ward.origion) > -1 }"
                                    :key="index"
                                >
                                    {{ ward.label }}
                                </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="btnconfirm">
                        <vbutton type="primary" class="btnselectroom" @click="cancelSelectRooms" block round>
                            重置
                        </vbutton>
                        <vbutton type="primary" class="btnselectroom" @click="confirmSelectRooms" block round>
                            确认
                        </vbutton>
                    </div>
                </vdropdownitem>
            </vdropdownmenu>
            <div class="box_4 flex-row">
                <el-button :type="is_own == false ? 'primary' : ''" size="mini" @click="selectOwnSurgery(false)">全部</el-button>
                <el-button :type="is_own == true ? 'primary' : ''" size="mini" @click="selectOwnSurgery(true)">我的患者</el-button>
                <span class="align-right" style="position: absolute;right: 20px;top: 5px;font-size: 24px;font-weight: bold;" title="完成数/汇总数">{{completedCount}}/{{allCount}}</span>
            </div>
            <div class="list_3 flex-col" :style="{ height: `${this.screenHeight - 230}px` }" style="overflow-y: auto;overflow-x: hidden;">
                <vpullrefresh v-model="refreshing" @refresh="onRefresh">
                    <vlist v-model="loading" :finished="finished" finished-text="" @load="onLoad">
                        <div v-if="_surgeryList.length > 0" style="padding: 0px 10px 0px 10px;">
                            <div class="list-items_3 flex-col" v-for="(item, index) in _surgeryList" :key="index" @click="goPath(item)">
                                <div class="statusdiv" :style="getstatuscolor(item)">{{item.surgery_status}}</div>
                                <div class="group_9 flex-row justify-between">
                                    <span class="text_17">
                                        {{item.patient_name}} &nbsp;
                                        <span class="text_18">{{item.sex||'-'}}/{{item.age||'-'}}/{{item.bed_no||'-'}}/{{item.visit_no||'-'}}</span>
                                    </span>
                                </div>
                                <div class="group_10 flex-row justify-between">
                                    <div class="image-text_31 flex-row" style="justify-content: left;">
                                        <!-- <img class="thumbnail_36" referrerpolicy="no-referrer" src="static/img/mobile/mobile_surgery_name.png"  /> -->
                                        <span class="text-group_29">{{item.surgeries}}</span>
                                    </div>
                                    <!-- <img class="thumbnail_37" referrerpolicy="no-referrer" src="static/img/mobile/mobile_todetail.png"  /> -->
                                </div>
                                <div class="group_11 flex-row">
                                    <div class="image-text_32 flex-row" style="justify-content: left;">
                                        <!-- <img class="thumbnail_38" referrerpolicy="no-referrer" src="static/img/mobile/mobile_oper_room.png"  /> -->
                                        <span class="text-group_30">
                                            <span class="tip_30">
                                                {{item.dic_section || `--`}}
                                            </span>
                                            <span class="tip_30">
                                                {{item.dic_opearting_ward || `--`}}
                                            </span>
                                            <span class="tip_30" v-if="item.dic_operating_room">
                                                {{item.dic_operating_room}}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else style="display: flex;justify-content: center;align-items: center;" :style="{ height: `${this.screenHeight - 230}px` }">
                            <div style="font-size:20px;">暂无数据</div>
                        </div>
                    </vlist>
                </vpullrefresh>
                <vpopup v-model="showDatePickerPanel" round position="bottom">
                    <vdatetimepicker
                        v-model="currentDate"
                        type="date"
                        title="手术计划开始时间"
                        @cancel="showDatePickerPanel = false"
                        @confirm="confirmOperTime"
                        :min-date="minDate"
                        :max-date="maxDate"
                    />
                </vpopup>
            </div>
        </div>
        <div class="section_5 flex-row">
            <vtabbar v-model="activeBottomTabItem">
                <vtabbaritem icon="bars" class="thumbnail_39 text-group_31">患者列表</vtabbaritem>
                <vtabbaritem icon="bars" class="thumbnail_39 text-group_34">患者转运</vtabbaritem>
                <vtabbaritem icon="comment-o" class="thumbnail_39 text-group_34">我的</vtabbaritem>
            </vtabbar>
        </div>
        <el-dialog title="患者核对" :visible.sync="checkstatus.dialogFormVisible" width="80%" height="300px">
            <div style="font-size: 18px; text-align: left; margin-bottom: 20px; line-height: 30px">
                <vrow>
                    <vcol span="24">姓名：<b>{{ checkstatus.patient_name||'--' }}</b></vcol>
                </vrow>
                <vrow>
                    <vcol span="24">科室：<b>{{ checkstatus.dic_section || '--' }}</b></vcol>
                </vrow>
                <vrow>
                    <vcol span="24">住院号：<b>{{ checkstatus.visit_no || '--' }}</b></vcol>
                </vrow>
                <vrow>
                    <vcol span="24">床号：<b>{{ checkstatus.bed_no || '--' }}</b></vcol>
                </vrow>
                <vrow>
                    <vcol span="24">主刀：<b>{{ checkstatus.surgeon || '--' }}</b></vcol>
                </vrow>
                <vrow>
                    <vcol span="24">手术部位：<b>{{ checkstatus.surgical_site || '--' }}</b></vcol>
                </vrow>
                <vrow>
                    <vcol span="24">手术名称：<b>{{ checkstatus.surgeries || '--' }}</b></vcol>
                </vrow>
            </div>
                <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmPatientInfo(checkstatus)">确 定</el-button>
                <el-button type="primary" @click="checkstatus.dialogFormVisible = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import 'vant/lib/index.css'
import {
    Tab as vtab,
    Tabs as vtabs,
    DropdownMenu as vdropdownmenu,
    DropdownItem as vdropdownitem,
    Button as vbutton,
    PullRefresh as vpullrefresh,
    List as vlist,
    Empty as vempty,
    DatetimePicker as vdatetimepicker,
    Popup as vpopup,
    Tabbar as vtabbar,
    TabbarItem as vtabbaritem,
    Tag as vtag,
    Dialog,
    Field as vfield,
    Row as vrow,
    Col as vcol,
    Toast
} from 'vant'
import { mapGetters } from 'vuex'
export default {
    name: `BaseInfo`,
    components: {
        vtab,
        vtabs,
        vdropdownmenu,
        vdropdownitem,
        vbutton,
        vpullrefresh,
        vlist,
        vempty,
        vdatetimepicker,
        vpopup,
        vtabbar,
        vtabbaritem,
        vtag,
        [Dialog.Component.name]: Dialog.Component,
        vfield,
        vrow,
        vcol,
        Toast
    },
    data() {
        let sessionObj = null
        sessionObj = this.readSession()
        return {
            scan_userCode: sessionObj && sessionObj.scan_userCode || ``,
            operTimes: [
                { text: `今天`, value: 0 },
                { text: `本周`, value: 1 },
                { text: `本月`, value: 2 },
                { text: `自定义时间`, value: 3 }
            ],
            activeOperTime: sessionObj && sessionObj.activeOperTime || 1,
            showDatePickerPanel: false,
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2035, 12, 30),
            currentDate: sessionObj && sessionObj.currentDate || new Date(),
            allStatus: [
                { text: `全部`, value: 0 },
                { text: `新申请`, value: 10 },
                { text: `已排程`, value: 20 },
                { text: `手术中`, value: 30 },
                { text: `手术结束`, value: 40 },
                { text: `复苏中`, value: 50 },
                { text: `复苏结束`, value: 60 }
            ],
            activeStatus: sessionObj && sessionObj.activeStatus || 0,
            operateWards: [],
            operateWardIds: [],
            selectedOperateRoomIds: sessionObj && sessionObj.selectedOperateRoomIds || [],
            selectedRecoveryRoomIds: sessionObj && sessionObj.selectedRecoveryRoomIds || [],
            loading: false,
            finished: false,
            refreshing: false,
            surgeryList: [],
            activeBottomTabItem: 0,
            surgerSubStringRule: this.$root.SurgerSubStringRule,
            is_own: false,
            allCount: 0,
            completedCount: 0,
            checkstatus: {
                dialogFormVisible: false
            },
            hzhdEventId: 0 // 患者核对事件Id
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `screenHeight`, `ward_auth`, `active_hospital_ward`]),
        _surgeryList() {
            let that = this
            let search = this.getSearchCondition()
            let sk = (search.searchKey && search.searchKey.toUpperCase()) || ``
            let r = []
            r = _.filter(that.surgeryList, d => {
                let result = true
                if (result && this.operateWardIds.length > 0) {
                    result = _.includes(that.operateWardIds, d.dic_operating_ward_id)
                }
                if (result && search.operatingRoomIds.length > 0) {
                    result = _.includes(search.operatingRoomIds, d.dic_operating_room_id)
                }
                if (result && search.recoveryWardIds.length > 0) {
                    result = _.includes(search.recoveryWardIds, d.dic_recovery_ward_id)
                }
                if (result && this.is_own) {
                    result = d.is_own_data_auth_filter
                }
                if (result && sk.length > 0) {
                    result =
                        (d.patient_abbr && d.patient_abbr.toUpperCase().indexOf(sk) > -1) ||
                        (d.patient_name && d.patient_name.toUpperCase().indexOf(sk) > -1) ||
                        (d.visit_no && d.visit_no.toUpperCase().indexOf(sk) > -1) ||
                        (d.outpatient_no && d.outpatient_no.toUpperCase().indexOf(sk) > -1) ||
                        (d.his_id && d.his_id.toUpperCase().indexOf(sk) > -1) ||
                        (d.plan_anes_doctor && (d.plan_anes_doctor.label.toUpperCase().indexOf(sk) > -1 || d.plan_anes_doctor.jianpin.toUpperCase().indexOf(sk) > -1)) ||
                        (d.plan_anes_assistants && d.plan_anes_assistants.length > 0 && d.plan_anes_assistants.findIndex(i => { return i && i.label ? i.label.toUpperCase().indexOf(sk) > -1 : false }) > -1) ||
                        (d.plan_circuit_nurse && d.plan_circuit_nurse.length > 0 && d.plan_circuit_nurse.findIndex(i => { return i && i.label ? i.label.toUpperCase().indexOf(sk) > -1 : false }) > -1) ||
                        (d.plan_equipment_nurse && d.plan_equipment_nurse.length > 0 && d.plan_equipment_nurse.findIndex(i => { return i && i.label ? i.label.toUpperCase().indexOf(sk) > -1 : false }) > -1)
                }
                return result
            })
            // 已完成手术数量
            let status = [40, 50, 60]
            let completedrows = _.filter(r, d => { return _.includes(status, d.enum_surgery_status) }) || []
            that.completedCount = completedrows.length
            // 手术数量
            that.allCount = r.length
            console.log(`过滤后的数据`, r)
            if (r.length == 1 && that.scan_userCode != `` && r[0].enum_surgery_status < 30) {
                Object.assign(that.checkstatus, r[0])
                this.checkstatus.dialogFormVisible = true
            }
            return r
        }
    },
    created() {
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            // 获取手术区复苏区和手术间
            this.loadWardRooms()
            // 加载列表数据源
            this.loadAllTabData()
            // 获取患者核对事件Id
            this.loadCustomEvents()
        })
    },
    mounted() {
    },
    beforeRouteLeave(to, from, next) {
        if (to.path == `/m_detail`) {
            var search = {
                scan_userCode: this.scan_userCode,
                activeOperTime: this.activeOperTime,
                activeStatus: this.activeStatus,
                selectedOperateRoomIds: this.selectedOperateRoomIds,
                selectedRecoveryRoomIds: this.selectedRecoveryRoomIds,
                is_own: this.is_own,
                selectsurgeryType: this.selectsurgeryType,
                currentDate: this.activeOperTime == 3 ? this.currentDate : null,
                surgeryList: this.surgeryList
            }
            sessionStorage.setItem(`search`, JSON.stringify(search))
        }
        next()
    },
    methods: {
        getstatuscolor(item) {
            let bgcolor = `#A9A9A9`
            switch (item.enum_surgery_status) {
            case 10: // 新申请
                bgcolor = `#31c332`
                break
            case 20: // 已排程
                bgcolor = `#149682`
                break
            case 30: // 手术中
                bgcolor = `#ff4500`
                break
            case 50: // 苏醒中
                bgcolor = `#3CB371`
                break
            case -1: // 手术驳回
                bgcolor = `#DE7116`
                break
            case -2: // 手术终止
                bgcolor = `#DE7116`
                break
            case -201: // 手术取消审核中
                bgcolor = `#A9A9A9`
                break
            default:
                bgcolor = `#A9A9A9`
                break
            }
            return { background: bgcolor }
        },
        readSession() {
            // 读取暂存的查询条件
            let searchObj = sessionStorage.getItem(`search`)
            // let sessionUserCode = null
            // let sessionActiveOperTime = null
            // let sessionActiveStatus = null
            // let sessionSelectedOperateRoomIds = null
            // let sessionSelectedRecoveryRoomIds = null
            // let sessionIsOwn = null
            // let sessionSelectsurgeryType = null
            // let sessionCurrentDate = null
            let sessionObj = null
            if (searchObj && JSON.parse(searchObj) != null) {
                sessionObj = JSON.parse(searchObj)
                // sessionUserCode = obj.scan_userCode
                // sessionActiveOperTime = obj.activeOperTime
                // sessionActiveStatus = obj.activeStatus
                // sessionSelectedOperateRoomIds = obj.selectedOperateRoomIds
                // sessionSelectedRecoveryRoomIds = obj.selectedRecoveryRoomIds
                // sessionIsOwn = obj.is_own
                // sessionSelectsurgeryType = obj.selectsurgeryType
                // sessionCurrentDate = obj.currentDate
                // this.$nextTick(() => {
                //     if (this.$refs[`userCode`]) {
                //         this.$refs[`userCode`].scan_userCode = obj.scan_userCode
                //     }
                // })
            }
            return sessionObj
        },
        selectedRooms(roomId, type) {
            if (type == 1) {
                if (this.selectedOperateRoomIds.indexOf(roomId) > -1) {
                    this.selectedOperateRoomIds = this.selectedOperateRoomIds.filter(x => x != roomId)
                } else {
                    this.selectedOperateRoomIds.push(roomId)
                }
            } else {
                if (this.selectedRecoveryRoomIds.indexOf(roomId) > -1) {
                    this.selectedRecoveryRoomIds = this.selectedRecoveryRoomIds.filter(x => x != roomId)
                } else {
                    this.selectedRecoveryRoomIds.push(roomId)
                }
            }
        },
        cancelSelectRooms(value) {
            this.selectedOperateRoomIds = []
            this.selectedRecoveryRoomIds = []
            this.$refs.item.toggle()
        },
        confirmSelectRooms(value) {
            this.$refs.item.toggle()
        },
        confirmOperTime(value) {
            this.showDatePickerPanel = false
            this.loadAllTabData()
        },
        loadCustomEvents() {
            // 获取患者核对事件,后面记录事件时候需要使用
            let req = this.myaxios.get(`/api/AcisSystem/Event/GetEventByCode?code=CUST_HZHD`)
            req.then((evt) => {
                this.hzhdEventId = (evt && evt.id) || 0
            })
        },
        selectOwnSurgery(isOwn) {
            this.is_own = isOwn
        },
        getSearchCondition() {
            let begin = null
            let end = null
            switch (this.activeOperTime) {
            case 0:
                begin = this.$moment().format(`YYYY-MM-DD`)
                end = this.$moment().add(1, `days`).format(`YYYY-MM-DD`)
                break
            case 1:
                let weekOfDay = this.$moment().format(`E`)
                let firstday = this.$moment().subtract(weekOfDay - 1, `days`).format(`YYYY-MM-DD`)
                let endday = this.$moment().subtract(weekOfDay - 7, `days`).format(`YYYY-MM-DD`)
                begin = firstday
                end = endday
                break
            case 2:
                begin = this.$moment().startOf(`month`).format(`YYYY-MM-DD`)
                end = this.$moment().endOf(`month`).format(`YYYY-MM-DD`)
                break
            case 3:
                begin = this.$moment(this.currentDate).format(`YYYY-MM-DD`)
                end = this.$moment(this.currentDate).add(1, `days`).format(`YYYY-MM-DD`)
                break
            default:
                begin = this.$moment().format(`YYYY-MM-DD`)
                end = this.$moment().add(1, `days`).format(`YYYY-MM-DD`)
                break
            }

            let condition = {
                begin: begin,
                end: end,
                operatingRoomIds: this.selectedOperateRoomIds || [],
                recoveryWardIds: this.selectedRecoveryRoomIds || [],
                status: this.activeStatus == 0 ? [10, 20, 30, 40, 50, 60] : [this.activeStatus],
                searchKey: this.scan_userCode
            }
            return condition
        },
        loadAllTabData() {
            let that = this
            let search = this.getSearchCondition()
            return new Promise((resolve, reject) => {
                let req = that.myaxios.post(`/api/Preoperative/Apply/GetSurgeryWithStatus?begin=${search.begin}&end=${search.end}`, search.status)
                req.then(data => {
                    that.surgeryList = data
                    console.log(`加载的数据`, that.surgeryList)
                    that.finished = true
                    resolve(that.surgeryList)
                }).catch(e => {
                    that.finished = true
                    reject([])
                })
            })
        },
        // 获取区域和房间
        loadWardRooms() {
            let that = this
            let wards = _.filter(this.ward_auth && this.ward_auth.length > 0 ? this.ward_auth : [], ward => {
                return ward.groupId == that.active_hospital_ward.origion
            })
            if (wards && wards.length > 0) {
                that.operateWards = wards
                var ows = _.filter(wards, function(o) {
                    return o.value && _.includes(o.value, `ow_`)
                })
                that.operateWardIds = ows && _.uniq(ows.map(w => w.origion))
            }
        },
        onLoad() {},
        onRefresh() {
            let that = this
            this.loadAllTabData()
                .then(data => {
                    Toast(`刷新成功`)
                    that.refreshing = false
                })
                .catch(() => {
                    that.refreshing = false
                })
        },
        setscanActive() {
            setTimeout(() => {
                this.scanActive = true
            }, 2000)
        },
        openScan() {
            let that = this
            this.scanActive = false
            this.setscanActive()
            that.$refs.userCode && that.$refs.userCode.focus()
            // 存在cordova在打开
            // eslint-disable-next-line no-undef
            if (typeof cordova != `undefined`) {
                // eslint-disable-next-line no-undef
                if (!cordova.plugins.barcodeScanner) {
                    Dialog({ title: `提示信息`, message: `当前设备不支持扫码` })
                }
                // eslint-disable-next-line no-undef
                cordova.plugins.barcodeScanner.scan(
                    function(result) {
                        that.scan_userCode = that.substringcdata(result.text)
                    },
                    function(error) {
                        Dialog({ title: `提示信息`, message: `扫码失败` + error })
                    },
                    {
                        preferFrontCamera: false, // iOS and Android
                        showFlipCameraButton: true, // iOS and Android
                        showTorchButton: true, // iOS and Android
                        torchOn: false, // Android, launch with the torch switched on (if available)
                        saveHistory: true, // Android, save scan history (default false)
                        prompt: `请扫描二维码`, // Android
                        resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                        // formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                        orientation: `portrait`, // Android only (portrait|landscape), default unset so it rotates with the device
                        disableAnimations: true, // iOS
                        disableSuccessBeep: false // iOS and Android
                    }
                )
            } else {
                Dialog({ title: `提示信息`, message: `当前设备不支持扫码` })
            }
        },
        substringcdata(inputval) {
            let outval = ``
            if (this.surgerSubStringRule != ``) {
                let rulestr = this.surgerSubStringRule.split(`,`)
                let left = rulestr[0]
                let right = rulestr[1]
                if (left == 0 && right != 0) {
                    outval = inputval.substring(0, right)
                } else if (left != 0 && right != 0) {
                    outval = inputval.substring(left, right)
                } else {
                    outval = inputval
                }
            } else {
                outval = inputval
            }
            return outval
        },
        goPath(surgery) {
            this.$router.push({ name: `SurgeryDetail`, query: { surgeryId: surgery.id }, params: { surgeryInfo: surgery } }).catch(err => err)
        },
        handlerOperTime() {
            if (this.activeOperTime == 3) {
                this.showDatePickerPanel = true
            } else {
                this.loadAllTabData()
            }
        },
        confirmPatientInfo(surgeryInfo) {
            let that = this
            // 这里只是调后台记录一下
            let d = {
                biz_surgery_info_id: surgeryInfo.id,
                enum_record_type: 1,
                dic_event_id: this.hzhdEventId, // 记录患者核对事件
                display_order: 1
            }
            let req = this.myaxios.post(`/api/Intraoperative/Anaesthesia/PostOccurEvent`, d)
            req.then(data => {
                that.checkstatus.dialogFormVisible = false
            }).catch(e => {
                console.log(`PostOccurEvent返回错误`, e)
            })
        }
    },
    watch: {
        // activeOperTime: function(newVlaue, oldValue) {
        //     this.handlerOperTime()
        // },
        activeStatus: function(newVlaue, oldValue) {
            this.loadAllTabData()
        },
        $route: function(newUrl, oldUrl) {},
        activeBottomTabItem: function(newval, oldval) {
            if (newval == 0) {
                this.$router.push({ name: `BaseInfo` }).catch(err => err)
            }
            if (newval == 1) {
                this.$router.push({ name: `TransferList` }).catch(err => err)
            }
            if (newval == 2) {
                this.$router.push({ name: `MyInfo` }).catch(err => err)
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import './mobile_common.css';
.page {
    background-color: rgba(242, 242, 246, 1);
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.box_1 {
    background: url(/static/img/mobile/mobile_base_header.png) 100% no-repeat;
    background-size: 100% 100%;
    padding: 13px 15px 6px 16px;
}

.section_2 {
    margin-left: 4px;
}

.text_14 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 15px;
    letter-spacing: -0.30000001192092896px;
    font-family: SFProText-Semibold;
    font-weight: 600;
    text-align: right;
    white-space: nowrap;
    line-height: 18px;
}

.thumbnail_29 {
    width: 17px;
    height: 11px;
    margin: 4px 0 3px 219px;
}

.thumbnail_30 {
    width: 15px;
    height: 11px;
    margin: 3px 0 4px 5px;
}

.image_3 {
    width: 25px;
    height: 12px;
    margin: 3px 0 3px 5px;
}

.group_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    margin: 19px 1px 0 0;
    padding: 5px 211px 5px 13px;
}

.image-text_25 {
    width: 119px;
}

.label_1 {
    width: 32px;
    height: 22px;
}

.text-group_1 {
    overflow-wrap: break-word;
    color: rgba(153, 153, 153, 1);
    font-size: 15px;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 21px;
    /deep/ .el-input__inner{
        background-color: transparent;
        border: 0;
        line-height: 21px;
        height:21px;
        width:210px;
    }
    /deep/ .el-input__suffix{
        right:-100px;
    }
}

.section_3 {
    padding-bottom: 5px;
}

.image-text_26 {
    width: 74px;
}

.text-group_24 {
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
    font-size: 14px;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
}

.thumbnail_31 {
    width: 10px;
    height: 10px;
    margin: 6px 0 6px 0;
}

.image-text_27 {
    width: 74px;
}

.text-group_25 {
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
    font-size: 14px;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
}

.thumbnail_32 {
    width: 10px;
    height: 10px;
    margin: 6px 0 6px 0;
}

.image-text_28 {
    width: 74px;
}

.dropdownRooms {
    display: flex;
    height: 320px;
    overflow-y: scroll;
}

.wardpanel {
    text-align: left;
    font-size: 20px;
    padding: 5px;
}

.roompanel {
    display: flex;
    flex-wrap: wrap;

    .room {
        padding: 5px 10px;
        background: #f5f5f5;
        border-radius: 4px;
        font-size: 15px;
        color: #333333;
        line-height: 37px;
        margin: 6px;
    }

    .room_active {
        background: #e0f2f1;
        color: var(--primary-color, #009688);
    }
}

.btnconfirm {
    padding: 5px 16px;
    display: flex;
    justify-content: space-between;
}

.btnselectroom {
    background: var(--primary-color, #009688) !important;
    color: #ffffff;
    width: 100px;
}

.text-group_26 {
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
    font-size: 14px;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
}

.thumbnail_33 {
    width: 10px;
    height: 10px;
    margin: 6px 0 6px 0;
}

.box_4 {
    background-color: rgba(255, 255, 255, 1);
    padding: 7px 20px 6px 16px;
    position: relative;
}

.text_15 {
    overflow-wrap: break-word;
    color: rgba(0, 150, 136, 1);
    font-size: 14px;
    font-weight: normal;
    text-align: right;
    white-space: nowrap;
    line-height: 22px;
}

.text_16 {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-weight: normal;
    text-align: right;
    white-space: nowrap;
    line-height: 22px;
}

.group_3 {
    background-color: rgba(226, 245, 244, 1);
    border-radius: 14px;
    position: relative;
    margin: 2px 0 2px 93px;
    padding: 4px 36px 4px 8px;
}

.text_4 {
    overflow-wrap: break-word;
    color: rgba(0, 150, 136, 1);
    font-size: 14px;
    font-weight: normal;
    text-align: right;
    white-space: nowrap;
    line-height: 20px;
}

.label_2 {
    position: absolute;
    left: 38px;
    top: -5px;
    width: 38px;
    height: 38px;
}

.list_3 {
    width: 98%;
    align-self: center;
    margin-top: 8px;
}
.list_3::-webkit-scrollbar {
  display: none;
}
.list-items_3 {
    position: relative;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    height: 105px;
    margin-bottom: 12px;
    width: 100%;
    padding: 8px 14px 8px 12px;
}
.statusdiv {
    position: absolute;
    border-radius: 0px 4px 0px 4px;
    font-size: 13px;
    top: 0;
    right: 0;
    width: 70px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}
.group_9 {
    width: 98%;
    height: 24px;
    margin-right: 103px;
}

.text_17 {
    // width: 104px;
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 0.856);
    font-size: 16px;
    font-family: SourceHanSansCNVF-Medium;
    font-weight: bold;
    text-align: left;
    white-space: nowrap;
    line-height: 24px;
}

.text_18 {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-family: SourceHanSansCNVF-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 2px 0 0 -8px;
}

.text_19 {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-family: SourceHanSansCNVF-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 2px 0 0 8px;
}

.image-text_29 {
    width: 158px;
    margin: 2px 0 2px -8px;
}

.text-group_27 {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-family: SourceHanSansCNVF-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
}

.thumbnail_34 {
    width: 18px;
    height: 18px;
    margin: 1px 0 1px 0;
}

.image-text_30 {
    width: 158px;
    margin: 2px 0 2px 8px;
}

.text-group_28 {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-family: SourceHanSansCNVF-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
}

.thumbnail_35 {
    width: 18px;
    height: 18px;
    margin: 1px 0 1px 0;
}

.group_10 {
    width: 100%;
    margin: 8px 0 0 0px;
}

.image-text_31 {
    width: 148px;
}

.thumbnail_36 {
    width: 13px;
    height: 12px;
    margin: 5px 0 3px 0;
}

.text-group_29 {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 0.918);
    font-size: 16px;
    font-family: SourceHanSansCNVF-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 300px;
}

.thumbnail_37 {
    width: 6px;
    height: 11px;
    margin: 3px 0 6px 0;
}

.group_11 {
    margin: 10px 0 0 0;
}

.image-text_32 {
    width: 124px;
}

.thumbnail_38 {
    width: 16px;
    height: 16px;
    margin: 3px 0 1px 0;
}

.text-group_30 {
    overflow-wrap: break-word;
    // color: rgba(153, 153, 153, 1);
    font-size: 12px;
    font-family: SourceHanSansCNVF-Regular;
    font-weight: normal;
    // text-align: left;
    white-space: nowrap;
    line-height: 20px;
}
.tip_30{
    float: left;
    padding: 3px 7px 3px 7px;
    margin-right: 5px;
    color: #149281;
    background: #e0f4f4;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.section_5 {
    background-color: rgba(255, 255, 255, 1);
    margin-top: -1px;
    padding: 10px 40px 9px 30px;
}
.thumbnail_39 {
    width: 20px;
    height: 20px;
    align-self: center;
}

.text-group_31 {
    overflow-wrap: break-word;
    color: rgba(0, 150, 136, 1);
    font-size: 10px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: right;
    white-space: nowrap;
    line-height: 16px;
}

.image-text_34 {
    margin-left: 52px;
}

.thumbnail_40 {
    width: 20px;
    height: 20px;
    align-self: center;
}

.text-group_32 {
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
    font-size: 10px;
    font-weight: normal;
    text-align: right;
    white-space: nowrap;
    line-height: 16px;
}

.image-text_35 {
    margin-left: 61px;
}

.thumbnail_41 {
    width: 20px;
    height: 20px;
}

.text-group_33 {
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
    font-size: 10px;
    font-weight: normal;
    text-align: right;
    white-space: nowrap;
    line-height: 16px;
}

.image-text_36 {
    margin-left: 72px;
}

.thumbnail_42 {
    width: 20px;
    height: 20px;
}

.text-group_34 {
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
    font-size: 10px;
    font-weight: normal;
    text-align: right;
    white-space: nowrap;
    line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile/BaseInfo.vue